<div *ngIf="active" class="alert">
  <p><app-svg-icon icon="info-circle" size="medium"></app-svg-icon>
    <a href="https://www.avantiwestcoast.co.uk/travel-information/plan-your-journey/planned-engineering-works/trent-valley-engineering-work"
      target="_blank">Major upgrade work from 9 to 30 July</a>. Journeys will take longer while Network Rail improve the
    line.
  </p>
</div>